<template>
  <div class="p-24">
    <div class="text-14 font-semibold mb-20">Offers</div>
    <div class="overflow-hidden rounded-8 border border-gray-50">
      <table class="w-full">
        <tr class="border-b border-gray-50 text-gray-600 text-14">
          <th class="p-12">Process Chain Name</th>
          <th class="p-12">Process</th>
          <th class="p-12">Machine</th>
          <th class="p-12">Material</th>
          <th class="p-12 text-right">Average Cost per Kg</th>
          <th v-for="field in additionalFieldsToTemplate" :key="field.uid" class="p-12 h-48">
            {{ field.label }}
          </th>
        </tr>
        <tr
          v-for="template in profile?.process_chain_templates"
          :key="template"
          class="border-b border-gray-50 text-14"
        >
          <td class="p-12 h-48">{{ template.name }}</td>
          <td class="p-12 h-48">{{ template.prc_name }}</td>
          <td class="p-12 h-48">{{ template.machine }}</td>
          <td class="p-12 h-48">{{ template.material_name }}</td>
          <td class="p-12 h-48 text-right">
            {{ $formatPrice(template.avg_cost_per_kg) }}
          </td>
          <td v-for="field in additionalFieldsToTemplate" :key="field.uid" class="p-12 h-48">
            <SparkInput
              v-model="template.process_chain_template_description.description_items[field.uid]"
              :name="field.uid"
              :maxlength="250"
              @blur="setValueToDescriptionLabel(template.uid, template.process_chain_template_description.description_items[field.uid], field.uid)"
            />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Badge from '@/components/Reusable/Badge.vue';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';

export default {
  name: 'ExternalProfile',

  components: { Badge, SparkInput },

  props: {
    reloadTemplates: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      profile: {},
      additionalFieldsToTemplate: {},
    };
  },

  computed: {
    ...mapState('application', ['axiosInstance']),
  },

  watch: {
    reloadTemplates(newVal) {
      this.getExternalProfile();
      this.getTemplateDescriptionLabels();
    },
  },

  mounted() {
    this.getExternalProfile();
    this.getTemplateDescriptionLabels();
  },

  methods: {
    async getExternalProfile() {
      this.axiosInstance.get(`/api/v1/analysis-profile-list/`).then(response => {
        let profiles = response.data;
        let externalProfileUid = Object.keys(profiles).find(uid => profiles[uid].restriction === 'external');
        this.profile = profiles[externalProfileUid];
      });
    },

    async getTemplateDescriptionLabels() {
      await this.axiosInstance.get('/api/v1/description-list/').then(response => {
        this.additionalFieldsToTemplate = Object.values(response.data).sort((a, b) => a.order - b.order);
      });
    },

    async setValueToDescriptionLabel(templateUid, value, labelUid) {
      let formData = { process_chain_template_id: templateUid, description_id: labelUid, value: value };
      await this.axiosInstance.post(`/api/v1/template-description/`, formData).then(() => {});
    },
  },
};
</script>
